import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";

import { fetchAllCountriesAndStates } from "../../../services/apis";
import { AllCountriesAndStates } from "../../../types";

export default function LogoAddressComponent({ kpiCardData }: any) {
  const [allCountriesAndStates, setAllCountriesAndStates] = useState<AllCountriesAndStates[]>([]);

  const {
    data: allCountriesData,
    isLoading: isAllCountriesDataLoading,
    isSuccess: isAllCountriesDataSuccess,
  } = useQuery({
    queryKey: ["allCountries"],
    queryFn: fetchAllCountriesAndStates,
  });

  useEffect(() => {
    if (allCountriesData !== undefined && isAllCountriesDataSuccess && !isAllCountriesDataLoading) {
      const updatedData: AllCountriesAndStates[] = [];
      for (const i in allCountriesData?.data) {
        const itemSub = allCountriesData?.data[i];
        const { name, states, iso2 } = itemSub;
        const item: AllCountriesAndStates = {
          countryName: name,
          states: states,
          countryCode: iso2,
        };
        if (item.countryName === "United States" || item.countryName === "Canada") {
          updatedData.push(item);
        }
      }
      // console.log("updatedData ", updatedData);
      const sortedCountries = updatedData.sort((a, b) => a.countryName.localeCompare(b.countryName));
      console.log("sortedCountries ", sortedCountries);
      setAllCountriesAndStates(sortedCountries);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allCountriesData, isAllCountriesDataSuccess, isAllCountriesDataLoading]);

  const getStateCode = (input: string): string | null => {
    if (!input) return null;

    const normalizedInput = input.toLowerCase().trim();

    for (const country of allCountriesAndStates) {
      // check by full state name
      let foundState = country.states.find((s) => s.name.toLowerCase() === normalizedInput);

      // if not found, check by abbreviation
      if (!foundState) {
        foundState = country.states.find((s) => s.state_code.toLowerCase() === normalizedInput);
      }

      if (foundState) {
        return foundState.state_code;
      }
    }
    return null;
  };

  return (
    <Box>
      {/* {kpiCardData?.project_data?.logo_url && <img src={kpiCardData?.project_data?.logo_url} alt="PaceLogo" style={{ height: "45px", objectFit: "contain" }} />} */}
      <Typography id="modal-modal-title" variant="body1">
        {kpiCardData ? (
          <>
            {kpiCardData?.project_data?.address_line_1} <br />
            {kpiCardData?.project_data?.address_line_2 ? (
              <>
                {kpiCardData?.project_data?.address_line_2} <br />
              </>
            ) : null}
            {kpiCardData?.project_data?.city ? <>{kpiCardData?.project_data?.city},&nbsp;</> : null}
            {kpiCardData?.project_data?.state ? <>{getStateCode(kpiCardData?.project_data?.state)}&nbsp;</> : null}
            {kpiCardData?.project_data?.postal_code ? (
              <>
                {kpiCardData?.project_data?.postal_code}
                <br />
              </>
            ) : null}
            {kpiCardData?.project_data?.phone_number ? <>{kpiCardData?.project_data?.phone_number}</> : null}
          </>
        ) : (
          <>
            625 S. The City Drive <br />
            Orange, CA 912345 <br />
            949-123-4567
          </>
        )}
      </Typography>
    </Box>
  );
}
